// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"92":"833c6988","374":"60164052","431":"cbc906b9","679":"e9d5b38e"}[chunkId] + ".css";
};